export function handleNavigations() {
    let $body = $('body');
    let $windowWidth = $(window).outerWidth();
    let mediumBreakpoint = 1280;
    let smallBreakpoint = 1024;
    let $navDropdownSidebar = $('.js-nav-dropdown-sidebar');

    $body.on('click', '.js-toggle-sub-nav', function () {
        if ($windowWidth < smallBreakpoint) {
            if ($(this).hasClass('nav__link--dropdown-active')) {
                $('.nav__link--dropdown-active').removeClass('nav__link--dropdown-active');
                $('.nav-dropdown').removeClass('nav-dropdown--active');
            } else {
                $('.nav__link--dropdown-active').removeClass('nav__link--dropdown-active');
                $('.nav-dropdown').removeClass('nav-dropdown--active');
                $(this).toggleClass('nav__link--dropdown-active').closest('.nav__item--dropdown').find('.nav-dropdown').toggleClass('nav-dropdown--active');
            }
            return false;
        }
    }).on('mouseover', '.js-toggle-sub-nav, .nav-dropdown', function () {
        $('main').addClass('overlay-active');
    }).on('mouseleave', '.js-toggle-sub-nav, .nav-dropdown', function () {
        $('main').removeClass('overlay-active');
    }).on('click', '.js-toggle-inner-sub-nav', function () {
        if ($windowWidth < smallBreakpoint) {
            let type = $(this).attr('data-type');
            let $targetSidebarSection = $('.js-nav-dropdown-sidebar-section[data-type="' + type + '"]');
            $('.sub-nav__link--active').removeClass('sub-nav__link--active');
            $(this).addClass('sub-nav__link--active');
            $('.js-nav').addClass('nav--sub-inner-nav-active');
            $navDropdownSidebar.addClass('nav-dropdown__sidebar--active');
            $('.nav-dropdown__sidebar-section--active').removeClass('nav-dropdown__sidebar-section--active');
            $targetSidebarSection.addClass('nav-dropdown__sidebar-section--active');

            if ($windowWidth >= smallBreakpoint) {
                let sidebarWidth = $targetSidebarSection.outerWidth();
                let sidebarHeight = $targetSidebarSection.outerHeight();

                let $mainSidebar = $('.nav-dropdown__main');
                let mainSidebarHeight = $mainSidebar.outerHeight();

                if (sidebarHeight < mainSidebarHeight) {
                    $navDropdownSidebar.css({'width': sidebarWidth, 'height': mainSidebarHeight});
                } else {
                    $navDropdownSidebar.css({'width': sidebarWidth, 'height': sidebarHeight});
                }
                return;
            }
            return false;
        }
    }).on('mouseover', '.js-toggle-inner-sub-nav', function () {
        if ($windowWidth >= smallBreakpoint) {
            $('.nav-dropdown__sidebar-section--active').removeClass('nav-dropdown__sidebar-section--active');
            $(this).closest('.nav-dropdown__main').removeClass('nav-dropdown__main--sidebar-open');

            let type = $(this).attr('data-type');
            let $targetSidebarSection = $('.js-nav-dropdown-sidebar-section[data-type="' + type + '"]');
            $targetSidebarSection.addClass('nav-dropdown__sidebar-section--active');

            $(this).closest('.nav-dropdown__main').addClass('nav-dropdown__main--sidebar-open');

            let sidebarWidth = $targetSidebarSection.outerWidth();
            let sidebarHeight = $targetSidebarSection.outerHeight();

            $navDropdownSidebar.css({'width': sidebarWidth, 'height': sidebarHeight});
        }
    }).on('mouseenter', '.js-hide-nav-sidebar', function () {
        if ($windowWidth >= smallBreakpoint) {
            $('.nav-dropdown__sidebar-section--active').removeClass('nav-dropdown__sidebar-section--active');
            $('.nav-dropdown__main').removeClass('nav-dropdown__main--sidebar-open');
            $navDropdownSidebar.attr('style', '');
        }
    }).on('mouseover', '.js-nav-dropdown-sidebar-section', function () {
        if ($windowWidth >= smallBreakpoint) {
            let type = $(this).attr('data-type');
            $('.js-toggle-inner-sub-nav[data-type="' + type + '"]').addClass("hover");
        }
    }).on('mouseleave', '.js-nav-dropdown-sidebar-section', function () {
        if ($windowWidth >= smallBreakpoint) {
            $('.js-toggle-inner-sub-nav').removeClass("hover");
        }
    }).on('focusin', '.js-nav-dropdown-sidebar-section', function(){
        if ($windowWidth >= smallBreakpoint) {
            let type = $(this).attr('data-type');
            console.log(type);
            $(this).addClass('nav-dropdown__sidebar-section--active');
            let $targetSidebarSection = $('.js-nav-dropdown-sidebar-section[data-type="' + type + '"]');
            let sidebarWidth = $targetSidebarSection.outerWidth();
            let sidebarHeight = $targetSidebarSection.outerHeight();

            $navDropdownSidebar.css({'width': sidebarWidth, 'height': sidebarHeight});
        }

    }).on('blur', '.js-nav-dropdown-sidebar-section', function(){
        $(this).removeClass('nav-dropdown__sidebar-section--active');
    }).on('click', '.js-mobile-menu-back-btn', function () {
        $(this).closest('.nav-dropdown').removeClass('nav-dropdown--active');
    }).on('click', '.js-mobile-inner-menu-back-btn', function () {
        $(this).closest('.nav-dropdown__sidebar').removeClass('nav-dropdown__sidebar--active');
        setTimeout(function () {
            $('.nav-dropdown__sidebar-section--active').removeClass('nav-dropdown__sidebar-section--active');
        }, 250);
    }).on('click', '.js-nav-dropdown-toggle', function () {
        $(this).closest('.nav__item--dropdown').toggleClass('nav__item--active').find('.nav-dropdown').stop().slideToggle();
    }).on('mouseover', '.js-healthcare-nav-dropdown', function () {
        $(this).closest('.nav__item--dropdown').find('.js-toggle-sub-nav').addClass('nav__link--hover-active');
    }).on('mouseleave', '.js-healthcare-nav-dropdown', function () {
        $('.nav__link--hover-active').removeClass('nav__link--hover-active');
        $navDropdownSidebar.attr('style', '');
    }).on('click', '.js-our-hospitals-dropdown', function () {
        $(this).closest('.nav-link--dropdown').toggleClass('nav-link--active');
    });

    $(window).on('resize load', function () {
        $windowWidth = $(window).outerWidth();
        $('body').css('--header-height', $('.js-header').outerHeight() + 'px');

        if ($windowWidth >= smallBreakpoint) {
            $('.nav__link--dropdown-active').removeClass('nav__link--dropdown-active');
            $('.nav-dropdown--active').removeClass('nav-dropdown--active');
            $('.sub-nav__link--active').removeClass('sub-nav__link--active');
            $('.nav-dropdown__sidebar-section--active').removeClass('nav-dropdown__sidebar-section--active');
            $(this).closest('.nav-link--dropdown').removeClass('nav-link--active');
        }
    });
}
